export class PatientDeviceRequest {
    public idPatient?: number | null = null;
    public idHealthUnitCreator?: number | null = null;
    public idHealthUnitDevice?: number | null = null;
    public patientName: string | null = null;
    public cpf: string | null = null;
    public birthDate?: Date | null = null;
    public datetimeInclusion?: Date | null = null;
    public idGender?: number | null = null;
    public zipCode?: string | null = null;
    public street?: string | null = null;
    public neighborhood: string | null = null;
    public city: string | null = null;
    public state: string | null = null;
    public country: string | null = null;
    public phone1: string | null = null;
    public houseNumber: string | null = null;
    public apartmentNumber: string | null = null;

    public idPatientEmployee?: number | null = null;
    public unitBranch: string | null = null;
    public sectorEmployee: string | null = null;
    public roleEmployee: string | null = null;
    public registryEmployee: string | null = null;
}